<template>
  <div v-show="showPicker" class="zendesk-filepicker">
    <click-outside :handler="close" id="zendesk-filepicker-co" class="fp-popup" style="width: 80%; max-height: 91%; overflow-y: scroll">
      <FilePickerHeader :logo="logo" connector="zendesk" :user="user" :domain="domain" :key="'zendesk'"
                        @close-filepicker="close"/>
      <div class="filepicker-selector-container">
        <div style="display: inline-flex; width: 100%;" v-if="categories.length">
          <div class="filepicker-input-item">
            <div class="bold">Select Category</div>
            <v-select :options="categories"
                      v-model="selectedCategory"
                      class="v-select-styling"
                      label="name"
                      @input="loadSectionsForCategory"></v-select>
          </div>
          <div class="filepicker-input-item">
            <div class="bold">Select Section</div>
            <v-select :options="sections"
                      label="name"
                      v-model="selectedSection"
                      class="v-select-styling"
                      @input="loadArticlesForSection"></v-select>
          </div>
          <div class="filepicker-input-item" v-if="articleCount > 0">
            <div class="bold">Sort By</div>
            <v-select :options="sortOptions"
                      label="label"
                      v-model="sortBy"
                      class="v-select-styling"
                      @input="selectSortBy"></v-select>
          </div>
        </div>
      </div>
      <div class="picker-subheader">
        <div class="picker-subheader-text flex">
          <div>Select Files <span v-if="articleCount > 0">&nbsp;({{ articleCount }})</span></div>
          <div class="flex" v-if="this.articlePageCount > 1">
            Page: &nbsp;
            <div v-for="(page, key) in this.articlePageCount" @click="page">
              <button :class="page === articlePage ? 'page-button-selected': 'page-button'"
                      @click.prevent="setArticlePage(page)">{{ page }}
              </button>
            </div>
          </div>
        </div>
        <div class="picker-subheader-selected-text">
          <div>Selected Files <span v-if="selectedArticleCount > 0">&nbsp;({{ selectedArticleCount }})</span>
          </div>
        </div>
      </div>
      <div>
      </div>

      <div class="filepicker-body">
        <div class="picker-search-container">
          <div class="picker-subheader-text flex">
            <input class="search-bar-input" v-model="searchTerm" placeholder="Search..."/>
          </div>
        </div>
        <div class="file-tree">
          <div class="all-files">
            <div class="file-picker-tree">
              <div v-if="this.loadingFiles">
                Loading...
              </div>
              <div v-else class="selected-file" style="display: block" v-for="(article, k) in articles"
                   :key="article.id">
                <div @click="articleSelected(article)" :title="article.title"
                     class="article-name artt-cursor"
                     :class="articleSelectionClass"
                     :id="article.id + '-article-un-selected'"
                >
                  {{ article.title }}
                  <a :href="article.html_url" target="_blank">
                    <img src="/images/open-new-tab.png" title="Open in new tab" style="width: 10px"/>
                  </a>
                </div>
                <div class="flex">
                  <div>
                    <button class="locale-pill"
                            @click.prevent
                            disabled
                    >{{ article.locale }}
                    </button>
                    <span v-if="article.translations.length > 1"> ➤ </span>
                  </div>
                  <div v-for="translation in article.translations" :key="translation.id">
                    <button class="locale-pill"
                            v-if="article.locale !== translation.locale"
                            @mouseover="showArticlePreview(translation, false)"
                            @mouseleave="showArticlePreview(translation, false)"
                            @click.prevent
                            disabled
                    >{{ translation.locale }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="selected-files">
          <div class="file-picker-tree">
            <div class="selected-file" style="list-style: none" v-for="(article, k) in selectedArticles" :key="k">
              <div class="article-name zendesk-font-color" :title="article.title">{{ article.title }}</div>
              <div>
                <a
                    @click="articleDeselected($event, article, k)"
                    type="button" style="cursor: pointer">&nbsp;x
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="picker-footer-links" v-if="this.articleCount > 0 || this.selectedArticleCount > 0">
        <div class="picker-subheader-text flex">
          <div class="picker-footer-link">
            <a
                title="Select all articles with out of date translated versions"
                v-if="this.articleCount > 0"
                class="picker-footer-link"
                @click.prevent="outOfDateTranslations">
              Select Outdated
            </a>
          </div>
          <div class="picker-footer-link">
            <a
                title="Select all articles that do not have translations"
                v-if="this.articleCount > 0"
                class="picker-footer-link"
                id="zendesk-missing"
                @click.prevent="missingArticles">
              Select Untranslated
            </a>
          </div>
          <div class=picker-footer-link>
            <a
                title="Select all"
                v-if="this.articleCount > 0"
                class="picker-footer-link"
                @click.prevent="selectAllArticles">
              Select All
            </a>
          </div>
        </div>
        <div class="picker-footer-links-selected-text">
          <div class="picker-footer-link">
            <a
                class="picker-footer-link"
                v-if="this.selectedArticleCount > 0"
                @click.prevent="deselectAllArticles">
              Clear
              Selection
            </a>
          </div>
        </div>
      </div>
      <div class="filepicker-footer">
        <button class="cancel-btn" id="zendesk-cancel" @click.prevent="cancel">Cancel
        </button>
        <button
            class="filepicker-bt"
            id="zendesk-upload-files"
            :class="submitButtonClass"
            @click.prevent="upload"
        >
          {{ submitButtonText }}
        </button>
      </div>
    </click-outside>
    <div class="fp-mask" :style="{ display: showPicker ? 'block' : 'none' }"></div>
  </div>
</template>

<script>
import '../style.scss';
import ClickOutside from 'onclick-outside';
import axios from "axios";
import {reject, chunk} from 'lodash';
import FilePickerHeader from "../FilePickerHeader";
import {mapActions, mapGetters, mapState} from "vuex";

// TODO break into components

let CancelRequest = null;
let $token = $("#token");

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

if ($token.length) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = $token.attr('content');
}
else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

export default {
  name: "ZendeskFilePicker",
  props: [
    'logo'
  ],
  data () {
    return {
      showPicker: false,

      articles: {},
      articlePage: 1,
      articlePageCount: 1,
      selectedArticles: [],
      searchTerm: '',

      categories: [],
      selectedCategory: undefined,

      sections: [],
      selectedSection: undefined,

      user: undefined,
      domain: undefined,
      orderId: undefined,

      showPreview: false,
      previewContent: '',
      loadingFiles: false,
      loadedOnce: false,

      sortBy: {
        label: 'Last Updated',
        name: 'updated_at'
      },
      sortOptions: [
        {
          label: 'Title',
          name: 'title'
        },
        {
          label: 'Last Updated',
          name: 'updated_at'
        },
        {
          label: 'Created At',
          name: 'created_at'
        },
      ],
      loadResult: 'Loading...',
      submitButtonText: 'Upload Files'
    };
  },
  components: {
    FilePickerHeader,
    'click-outside': ClickOutside
  },
  watch: {
    showPicker: function (val, oldVal) {
      if (val) {
        this.loadCategories();
      }
    },
    searchTerm: function (val, oldVal) {
      this.loadArticlesForSection();
    }
  },
  mounted () {
    EventBus.$on("show-zendesk-picker", (data) => {
      this.showPicker = true;
      this.orderId = data?.orderId;

      if (!this.user && !this.loadedOnce) {
        axios.get(`/connectors/zendesk/picker/user`)
            .then(response => {
              if (!response.data.success) {
                return;
              }
              this.user = response.data.email;
              this.domain = response.data.domain;
            }).catch(function (error) {
        });
      }
      this.loadedOnce = true;
    });
  },
  computed: {

    //counters
    selectedArticleCount () {
      return this.selectedArticles.length;
    },
    articleCount () {
      return this.articles ? Object.values(this.articles).length : 0;
    },
    articleSelectionClass: function () {
      // let selected = this.articleInSelected(article);
      // return {
      //   'zendesk-bt-disabled': selected,
      //   'zendesk-bt-secondary': !selected,
      // };
    },
    //computed bound classes
    submitButtonClass: function () {
      return {
        'disabled-btn': this.selectedArticleCount === 0,
        'bbutton': this.selectedArticleCount > 0,
      };
    },
    multiSelectButtonClass: function () {
      return {
        'zendesk-link-disabled': this.articleCount === 0,
        'zendesk-link-secondary': this.articleCount > 0,
      };
    },
    linkClass: function () {
      return {
        'picker-footer-link-disabled': this.articleCount === 0,
        'picker-footer-link': this.articleCount > 0,
      };
    },
    ...mapState({
      source_language: state => state.CreateOrderStore.selectLanguages.source_language,
      uploadFileType: state => state.CreateOrderStore.orderDetails.uploadFileType,
      features: state => state.store.features,
    }),
    ...mapGetters('FeatureFlagStore', {
      'getFeature': 'getFeatureStatusByName'
    }),
  },
  methods: {
    //LOADERS
    loadCategories () {
      this.loadResult = 'Loading...';
      axios.get(`/connectors/zendesk/picker/categories`)
          .then(response => {
            if (!response.data.categories.length) {
              this.loadResult = 'No categories found...';
            }
            this.categories = response.data.categories;
          }).catch(function (error) {
      });
    },
    loadSectionsForCategory () {

      if (!this.selectedCategory) {
        return;
      }

      this.articles = {};

      axios.get(`/connectors/zendesk/picker/categories/${this.selectedCategory.id}/sections`)
          .then(response => {
            this.selectedSection = undefined;
            this.sections = response.data.sections;
          }).catch(function (error) {
      });
    },
    loadArticlesForSection () {

      if (!this.selectedSection) {
        return;
      }

      let sourceLang = this.source_language;

      if (!sourceLang) {
        alert('Please select a source language for the order so we can get your articles by locale.');
        return false;
      }

      this.loadingFiles = true;
      let query = `?page=${this.articlePage}&sort_by=${this.sortBy.name}&searchTerm=${this.searchTerm}&sourceLang=${sourceLang}`;
      let url = `/connectors/zendesk/picker/sections/${this.selectedSection.id}/articles${query}`;

      axios.get(url)
          .then(response => {
            this.articles = response.data.articles;
            this.articlePageCount = response.data.page_count;
            this.loadingFiles = false;
          }).catch(function (error) {
        this.loadingFiles = false;
      });
    },
    // SELECTORS
    categorySelected () {
      this.selectedSection = undefined;
      this.articles = undefined;
      this.loadSectionsForCategory();
    },
    sectionSelected () {
      this.articles = undefined;
      this.loadArticlesForSection();
    },
    setArticlePage (page) {
      this.articlePage = page;
      this.loadArticlesForSection();
    },
    articleSelected (article) {
      if (!this.articleExistsInSelectedArticles(article)) {
        article.selected = true;
        this.selectedArticles.push(article);
        let id = article.id;
      }
    },
    articleDeselected (index, article, k) {
      this.selectedArticles = reject(this.selectedArticles, function (art) {
        return art.id === article.id;
      });
      article.selected = false;
    },
    selectAllArticles () {
      this.articles.forEach((article, idx) => {
        let id = article.id;
        article.selected = true;
        this.articleInSelected(article) ? this.selectedArticles.push(article) : false;
      });
    },
    deselectAllArticles () {
      this.selectedArticles.forEach((art, i) => {
        let id = art.id;
        art.selected = false;
      });
      this.selectedArticles = [];
    },
    showArticlePreview (article, bool) {
      if (bool) {
        $('#' + article.id + '-preview').show();
      }
      else {
        $('#' + article.id + '-preview').hide();
      }
    },
    articleExistsInSelectedArticles (article) {
      return this.selectedArticles.some(art => art.id === article.id);
    },
    missingArticles () {
      let hasMissing = false;
      // get all articles that don't have translations
      this.articles.forEach((article, i) => {
        if (!this.articleExistsInSelectedArticles(article)) {
          // no translations
          if (article.translations.length === 1) {
            this.articleSelected(article);
            hasMissing = true;
          }
        }
      });

      if (!hasMissing) {
        alert("No articles with missing translations...");
      }

    },
    selectSortBy (sortByOption) {

      this.loadArticlesForSection();

    },
    outOfDateTranslations () {
      let hasOutOfDate = false;
      // for each article
      this.articles.forEach((article, i) => {
        // if the article doesn't exist already
        if (!this.articleExistsInSelectedArticles(article)) {

          // get og date
          let originalArticleDate = new Date(article.updated_at);

          let locale = article.locale;

          // for each translation that not the locale
          article.translations
              // skip the og locale
              .filter(article => article.locale !== locale)
              .forEach((translation, i) => {

                let translationDateCreated = new Date(translation.created_at);
                let translationDateUpdated = new Date(translation.updated_at);

                // debug table
                // console.table({
                //   tlocale: translation.locale,
                //   translationDateCreated: translationDateCreated,
                //   translationDateUpdated: translationDateUpdated,
                //   originalArticleDate: originalArticleDate
                // });

                if (originalArticleDate > translationDateCreated && originalArticleDate > translationDateUpdated) {
                  this.articleSelected(article);
                  hasOutOfDate = true;
                }
              });
        }
      });

      if (!hasOutOfDate) {
        alert("No out of date translations...");
      }

    },
    articleInSelected (article) {

      return this.selectedArticles.indexOf(article) === -1;

    },
    upload () {

      if (this.selectedArticleCount === 0) {
        return;
      }

      this.submitButtonText = 'Loading...';

      let orderId = this.orderId;

      //check if the order id was previously set
      if (!orderId) {
        orderId = $("#order_id").val() === undefined ? 0 : $("#order_id").val(); // TODO
      }

      // add articles for minified array for sending to backend
      const articles = []

      for (const [i_, value] of Object.entries(this.selectedArticles)) {
        articles.push({
          name: value.name,
          id: value.id,
          section_id: value.section_id,
          html_url: value.html_url,
          body: value.body,
          title: value.title,
        })
      }

      // upload async 20 at a time
      const chunks = chunk(articles, 5)

      const count = chunks.length
      let done_uploading = 0
      this.submitButtonText = `Upload Started...`;

      chunks.forEach((articleChunks, key, arr) => {
        $.ajax({
          url: '/connectors/zendesk/picker/upload',
          data: {
            type: this.uploadFileType,
            orderId: orderId,
            articleIds: articleChunks
          },
          method: 'post',
          success: (d) => {
            done_uploading += 1
            this.submitButtonText = `Uploading ${Math.floor((done_uploading/count) * 100)}%`;

            // let any listeners know about the new file
            EventBus.$emit('file-uploaded');

            if (done_uploading === count) {
              // execute last item logic
              this.submitButtonText = 'Upload';
              this.close();
            }
          }, error: (e) => {
            console.error("Chunk failed", [e, articleChunks]);
            done_uploading += 1
            this.submitButtonText = `Uploading ${(done_uploading/count) * 100}%`;
            if (done_uploading === count) {
              // execute last item logic
              this.submitButtonText = 'Upload';
              this.close();
            }
          }
        });
      });

    },

    // cleanup functions
    close () {
      if (!this.showPicker) return;
      this.clearAllTheThings();
      this.showPicker = false;
    },
    cancel (e) {
      this.clearAllTheThings();
      this.showPicker = false;
    },
    //initiate shutdown sequence
    clearAllTheThings () {
      this.deselectAllArticles();
      this.selectedArticles = [];
      this.selectedSection = undefined;
      this.selectedCategory = undefined;
      this.articles = {};
      this.sections = [];
      this.categories = [];
      this.articlePageCount = 1;
      this.errored = false;
      this.searchTerm = '';
    },

  },
};
</script>
